import * as Yup from 'yup'
import { getSS } from '../helpers'
import './methods.js'

const paymentMethodDirectDebit = getSS('donation').payment_method === 'DirectDebit'

const homepage = Yup.object().shape({
    // appeal_id: Yup
    // .string(),
    // appeal_name: Yup
    //   .string(),
    // ga_document_host: Yup
    //   .string(),
    // ga_tracking_id: Yup
    //   .string(),
    // gtm_container_id: Yup
    //   .string(),
    // initial_location: Yup
    //   .string(),
    // session_id: Yup
    //   .string(),
    payment_type: Yup
      .string(),
    payment_method: Yup
      .string(),
    amount: Yup
      .number()
      .sepiaValidate('amount'),
    optins_post: Yup
      .boolean(),
    optins_email: Yup
      .boolean(),
    optins_phone: Yup
      .boolean(),
    optins_giftaid: Yup
      .boolean(),
    salutation: Yup
      .string()
      .sepiaValidate('salutation'),
    first_name: Yup
      .string()
      .sepiaValidate('first_name'),
    last_name: Yup
      .string()
      .sepiaValidate('last_name'),
    email: Yup
      .string()
      .sepiaValidate('email'),
    phone: Yup
      .string()
      .sepiaValidatePhone(),
    membership_number: Yup
      .string()
      .sepiaValidate('membership_number'),
    organisation: Yup
      .string(),
    address_1: Yup
      .string()
      .sepiaValidate('address_1'),
    address_2: Yup
      .string(),
    address_3: Yup
      .string(),
    town_city: Yup
      .string()
      .sepiaValidate('town_city'),
    county_state: Yup
      .string(),
    postcode: Yup
      .string()
      .sepiaValidatePostcode(),
    country: Yup
      .string(),
    message_to_charity: Yup
      .string()
})

const BankAccountName = paymentMethodDirectDebit ? {bank_account_account_name: Yup.string().required("Please enter the name of the account holder").sepiaValidate('bank_account_account_name')} : {bank_account_account_name: Yup.string()}
const BankAccountNumber = paymentMethodDirectDebit ? {bank_account_account_number: Yup.string().required("Please enter the account number").sepiaValidate('bank_account_account_number')} : {bank_account_account_number: Yup.string()}
const BankAccountSortCode = paymentMethodDirectDebit ? {bank_account_sort_code: Yup.string().required("Please enter the sort code").sepiaValidate('bank_account_sort_code')} : {bank_account_sort_code: Yup.string()}

const payment_regular = Yup.object().shape({
  ...BankAccountName,
  ...BankAccountNumber,
  bank_account_account_number_redacted: Yup
    .string(),
  ...BankAccountSortCode
})

const validation = { homepage, payment_regular }

export default validation